export class UwMemoStatusConstants {
  public static COMPLETED = "Completed";
  public static COMPLETED_NO_CHANGE = "Completed - No Change";
  public static IN_PROGRESS = "In Progress";
  public static MISSING_INFO = "Missing Information";
  public static RETRACTED = "Retracted";
  public static SENT = "Sent";
}
